import {useEffect} from "react";

export function useEvent<T>(name: string, callback: (value?: T) => void){

    const call = (e: CustomEventInit<T>) => {
        callback(e.detail);
    }

    useEffect(() => {
        document.addEventListener(name, call);
        return () => {
            document.removeEventListener(name, call);
        }
    });
}

export function publishEvent<T>(name: string, data?: T){
    const evt = new CustomEvent<T>(name, { detail: data })
    document.dispatchEvent(evt)
}